import { GraniteButton } from 'components/V2/Button/GraniteButton';
import PageTitle from 'components/PageTitle';
import { TableTitle } from 'components/Table/Table.styles';
import { DropdownButton } from '../../components/DropdownButton/DropdownButton';
import { People, Person } from 'react-ionicons';
import { DisplayForPermission } from 'components/Permission/DisplayForPermission';
import { useNavigate } from 'react-router-dom';
import { useModal } from '../../hooks/useModal';
import { BulkImportUsersDialog } from '../../components/BulkImportUsersDialog/BulkImportUsersDialog';
import Tabs from 'components/Table/Tabs';
import { FC, useMemo } from 'react';

interface UsersHeaderProps {
  onChangeActiveTab: (tab: 'existingUsers' | 'pendingInvitations') => void;
}

const UsersHeader: FC<UsersHeaderProps> = ({ onChangeActiveTab }) => {
  const navigate = useNavigate();

  const { open: bulkInviteDialogOpen, ...bulkInviteDialogProps } = useModal();

  const tabs = useMemo(
    () => [
      {
        title: 'Existing users',
        onClick: () => {
          onChangeActiveTab('existingUsers');
        },
        active: false,
      },
      {
        title: 'Pending invitations',
        onClick: () => {
          onChangeActiveTab('pendingInvitations');
        },
        active: false,
        className: 'product-tour-user-management-tab',
      },
    ],
    [onChangeActiveTab],
  );

  return (
    <>
      <div className="mb-6 flex w-full flex-col justify-between gap-4 md:flex-row md:items-start">
        <PageTitle title="User management" heightSpace={true} />
        <div className="flex items-center">
          <div className="product-tour-user-management-invite-user flex w-full flex-col items-center justify-end gap-4 xs:flex-row xs:flex-wrap">
            <DisplayForPermission onlyForSuperAdmin>
              <GraniteButton
                size="large"
                variant="secondary"
                onClick={() => navigate('/users/roles')}
                className="w-full xs:w-max"
              >
                Admin roles
              </GraniteButton>
            </DisplayForPermission>

            <GraniteButton
              size="large"
              variant="secondary"
              onClick={() => navigate('/users/custom-roles')}
              className="w-full xs:w-max"
            >
              Manage roles
            </GraniteButton>
            <DropdownButton
              className="product-tour-user-management product-tour-my-company-inviting-users w-full xs:w-max"
              label="Invite user"
              options={[
                {
                  label: (
                    <>
                      <Person
                        width="16px"
                        height="16px"
                        color="rgb(var(--content-base-default))"
                      />
                      <span className="ml-3">Invite user</span>
                    </>
                  ),
                  onClick: () => navigate('/users/invite-user/'),
                },
                {
                  label: (
                    <>
                      <People
                        width="16px"
                        height="16px"
                        color="rgb(var(--content-base-default))"
                      />
                      <span className="ml-3">Bulk invite</span>
                    </>
                  ),
                  onClick: bulkInviteDialogOpen,
                },
              ]}
            />
          </div>
        </div>
      </div>
      <TableTitle className="!mb-3">Users</TableTitle>
      <div className="mb-8 w-full">
        <Tabs tabs={tabs} />
      </div>
      <BulkImportUsersDialog {...bulkInviteDialogProps} />
    </>
  );
};

export default UsersHeader;
